import IInputProps, { ISlimInputProps } from "./IInputProps";
import InputContainer, { InputContainerRow } from "./InputContainer";

export default <T,>({ name, label, formik, placeholder, onChange }: IInputProps<T, number>) => {
    return (
        <InputContainer label={label} name={name} formik={formik}>
            <NumberInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} />
        </InputContainer>
    );
}

export const NumberInputRow = <T,>({ name, label, formik, placeholder, onChange }: IInputProps<T, number>) => {
    return (
        <InputContainerRow name={name} label={label} formik={formik}>
            <NumberInputSlim name={name} formik={formik} placeholder={placeholder} onChange={onChange} />
        </InputContainerRow>
    );
}

export const NumberInputSlim = <T,>({ name, formik, placeholder, onChange }: ISlimInputProps<T, number>) => {
    return (
        <input
            type="number"
            name={name as string}
            value={!Number.isNaN(formik.values[name]) && formik.values[name] !== null ? formik.values[name] as number : ""}
            onChange={e => {
                const value = !Number.isNaN(e.target.valueAsNumber) ? e.target.valueAsNumber : null;
                formik.setValues({
                    ...formik.values,
                    [name]: value,
                    ...onChange ? onChange(value) : {},
                });
            }}
            onBlur={formik.handleBlur}
            placeholder={placeholder}
        />
    );
}